import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel } from '@mui/material'
import { get, isAlreadyAccepted, post } from '../../api/api'
import { sessionActions, captureRequestOrigin } from '../../store/sessionActions'
import { UserModel } from '../../models/UserModel'
import { useTranslation } from 'react-i18next'

const UserAgreement: React.FC = () => {
    const { t, i18n } = useTranslation()
    const [checked, setChecked] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [content, setContent] = useState<string>('')

    useEffect(() => {
        const loadContent = async () => {
            const lang = i18n.language.split('-')[0]
            const paths = [`/locales/${lang}/UserAgreement.html`, `/locales/en/UserAgreement.html`]

            for (const path of paths) {
                try {
                    const response = await fetch(path)
                    if (response.ok) {
                        const text = await response.text()
                        setContent(text)
                        return
                    }
                } catch (error) {
                    console.error(`Failed to fetch UserAgreement from ${path}:`, error)
                }
            }
        }
        loadContent()
    }, [i18n.language])

    const onAgree = async () => {
        setIsSubmitting(true)
        const requestOrigin = captureRequestOrigin()

        try {
            const userModel = await post<UserModel>('/me/accept-agreement')
            sessionActions.userUpdated(userModel, requestOrigin)
        } catch (error) {
            if (isAlreadyAccepted(error)) {
                try {
                    const userModel = await get<UserModel>('/me')
                    sessionActions.userUpdated(userModel, requestOrigin)
                } catch (refetchError) {
                    console.warn('Failed to refetch user after an already-accepted response: ', refetchError)
                }
            } else {
                console.warn('Failed to sign a user agreement: ', error)
            }
        } finally {
            setIsSubmitting(false)
        }
    }
    return (
        <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>{t('user_agreement.title')}</DialogTitle>
            <DialogContent dividers sx={{ p: 2 }}>
                <div dangerouslySetInnerHTML={{ __html: content }} />
            </DialogContent>
            <DialogActions>
                <FormControlLabel
                    control={
                        <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} name="accept" />
                    }
                    label={t('user_agreement.agree_checkbox')}
                />
                <Button onClick={onAgree} disabled={!checked || isSubmitting} variant="contained" color="primary">
                    {t('user_agreement.agree_button')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default UserAgreement
